import React, { useEffect, useRef } from 'react';
import styles from './index.modules.less';

const HorizontalScroll = ({ children, callback, activeIndex, style }) => {
  const scrollContainerRef = useRef(null);
  const scrollOutRef = useRef(null);
  useEffect(() => {
    activeIndex > 0 && scrollToElement(activeIndex);
  }, [activeIndex]);
  const scrollToElement = (index) => {
    const scrollContainer = scrollContainerRef.current;
    const scrollOut = scrollOutRef.current;
    const childElement = scrollContainer.children[index];
    // 计算当前滚动的偏移量，使点击的元素滚动到中间位置
    const scrollAmount =
      childElement.offsetLeft - scrollOut.offsetWidth / 2 + childElement.offsetWidth / 2;
    scrollOut.scrollTo({ left: scrollAmount, behavior: 'smooth' });
  };
  return (
    <div className={styles['horizontal-scroll-container']} style={style || {}} ref={scrollOutRef}>
      <div className={styles['horizontal-scroll']} ref={scrollContainerRef}>
        {React.Children.map(children, (child, index) =>
          React.cloneElement(child, {
            onClick: () => {
              scrollToElement(index);
              callback && callback(index);
            }
          })
        )}
      </div>
    </div>
  );
};

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./src/components/HorizontalScroll/index.js